import {
    DataGrid,
    GridToolbarContainer,
} from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getFIles } from "../../Services/api";
import instance from "../../redux/api";
import format from "date-fns/format";
import { Stack, Typography, Box } from "@mui/material";
import { useStyles } from "../bankTransactions/bankTranscationContainerStyles";
import HistoryIcon from '@mui/icons-material/History';

const RecentUpload = ({ statementFieldsPrams }) => {
    console.log('statementFieldsPrams', statementFieldsPrams)
    const classes = useStyles();
    const toggle = useSelector((state) => state.toggleSideMenu);

    const [isLoading, setIsLoading] = useState(true);
    const [rows, setRows] = useState([]);

    const loadData = async () => {
        try {
            setIsLoading(true);

            // Static 10 records only
            const response = await instance.get(
                `${getFIles}?pageSize=10&module_name=${statementFieldsPrams}`
            );

            if (response.status === 200) {
                setRows(response?.data?.data ?? []);
            } else {
                setRows([]);
            }
        } catch (err) {
            console.error("err", err);
            setRows([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, [statementFieldsPrams]);

    const columns = [
        {
            field: "file_name",
            headerName: "File Name",
            flex: 3,
            headerAlign: "center",
        },
        {
            field: "module_name",
            headerName: "Module Name",
            flex: 1.5,
            headerAlign: "center",
        },
        {
            field: "file_info",
            headerName: "#Records",
            flex: 1,
            headerAlign: "center",
            renderCell: (params) => {
                try {
                    const data = JSON.parse(params.row.file_info);
                    return data?.record_count ?? 0;
                } catch {
                    return 0;
                }
            },
        },
        {
            field: "created_by",
            headerName: "Uploaded By",
            flex: 1.2,
            headerAlign: "center",
            renderCell: (params) => (
                <span>{params?.row?.created_by?.user_name || "-"}</span>
            ),
        },
        {
            field: "created_at",
            headerName: "Uploaded At",
            flex: 1.2,
            headerAlign: "center",
            renderCell: (params) => (
                <span>
                    {format(new Date(params.row.created_at), "dd-MM-yyyy")}
                </span>
            ),
        },
    ];

    return (
        <Box sx={{ height: 520, width: "100%" }}>
            {/* Title Section */}
            <Box sx={{ 
                display: "flex", 
                alignItems: "center", 
                gap: "12px", 
                marginBottom: "16px",
                padding: "0 4px"
            }}>
                <HistoryIcon sx={{ 
                    color: "#1672DE", 
                    fontSize: "24px",
                    animation: "pulse 2s ease-in-out infinite"
                }} />
                <Typography 
                    variant="h6" 
                    sx={{ 
                        color: "#1672DE", 
                        fontWeight: "600", 
                        fontSize: "18px",
                        letterSpacing: "-0.3px"
                    }}
                >
                    Recent Uploads
                </Typography>
            </Box>
            
            <DataGrid
                className={classes.pagination}
                loading={isLoading}
                rows={rows}
                columns={columns}
                getRowId={(row) => row.id}
                disableRowSelectionOnClick
                hideFooter
                // sx={{
                //     "& .MuiDataGrid-columnHeader[data-field='file_name']": {
                //         minWidth: toggle?.isOpen
                //             ? "170px !important"
                //             : "198px !important",
                //     },
                //     borderRadius: "20px"
                // }}
                sx={{
                    border: "none",
                    flex: 1,
                    minHeight: 0,
                    width: "100%",
                    height: "450px",
                    "& .MuiDataGrid-root": {
                        border: "none",
                        height: "100%",
                        width: "100%",
                    },
                    "& .MuiDataGrid-main": {
                        height: "100%",
                        "&::-webkit-scrollbar": {
                            width: "8px",
                            height: "8px",
                        },
                        "&::-webkit-scrollbar-track": {
                            background: "#f1f1f1",
                            borderRadius: "10px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                            background: "#1672DE",
                            borderRadius: "10px",
                            "&:hover": {
                                background: "#1565c0",
                            },
                        },
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: "#f8f9fa",
                        borderBottom: "2px solid #e0e0e0",
                        minHeight: "52px !important",
                        maxHeight: "52px !important",
                    },
                    "& .MuiDataGrid-columnHeader": {
                        backgroundColor: "transparent",
                        fontWeight: "600",
                        color: "#1672DE",
                        fontSize: "14px",
                        padding: "12px 16px",
                        borderBottom: "none",
                        "&:focus": {
                            outline: "none",
                        },
                        "&:focus-within": {
                            outline: "none",
                        },
                    },
                    "& .MuiDataGrid-row": {
                        borderBottom: "1px solid #f0f0f0",
                        "&:hover": {
                            backgroundColor: "rgba(22, 114, 222, 0.04) !important",
                        },
                        "&:nth-of-type(even)": {
                            backgroundColor: "#fafafa",
                            "&:hover": {
                                backgroundColor: "rgba(22, 114, 222, 0.04) !important",
                            },
                        },
                    },
                    "& .MuiDataGrid-cell": {
                        borderBottom: "none",
                        fontSize: "14px",
                        color: "#333",
                        padding: "12px 16px",
                        "&:focus": {
                            outline: "none",
                        },
                        "&:focus-within": {
                            outline: "none",
                        },
                    },
                    "& .MuiDataGrid-footerContainer": {
                        borderTop: "2px solid #e0e0e0",
                        backgroundColor: "#f8f9fa",
                        minHeight: "48px",
                        maxHeight: "48px",
                        paddingBottom: "8px",
                        paddingTop: "8px",
                        paddingLeft: "16px",
                        paddingRight: "16px",
                        position: "relative",
                        zIndex: 1,
                        "& .MuiTablePagination-root": {
                            color: "#666",
                            paddingRight: "16px",
                            margin: 0,
                            minHeight: "32px",
                        },
                        "& .MuiTablePagination-selectLabel": {
                            fontSize: "13px",
                            margin: 0,
                        },
                    },
                }}
                slots={{
                    toolbar: GridToolbarContainer,
                    noRowsOverlay: () => (
                        <Stack
                            height="100%"
                            alignItems="center"
                            justifyContent="center"
                        >
                            No Uploaded Files
                        </Stack>
                    ),
                }}
            />
        </Box>
    );
};

export default RecentUpload;
